export default "__VITE_ASSET__KHcG6Ui4__"